import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'aa-grid-container',
    templateUrl: './grid-container.component.html',
    styleUrls: [
        './grid-container.component.scss'
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class GridContainerComponent
{
}
